module.exports = __webpack_public_path__ + "static/img/makehole6.eb5dae8c.png";